import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { SccRegisterComponent } from './scc-register.component';
import { SccRegisterRoutingModule } from './scc-register-routing.module';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SccClinicModule } from './components/scc-clinic/scc-clinic.module';
import { SccUserComponent } from './components/scc-user/scc-user.component';
import { MatSelectModule } from '@angular/material/select';
import { SccPasswordModule } from '../../shared/components/scc-password/scc-password.module';
import {
  AutocompleteSelectorModule
} from 'src/app/shared/components/autocomplete-selector/autocomplete-selector.module';
import { MatCardModule } from '@angular/material/card';
import { SccPaymentComponent } from './components/scc-payment/scc-payment.component';
import {
  SccPaymentMethodInputComponent
} from '../../shared/components/scc-payment-method-input/scc-payment-method-input.component';
import { MatRadioModule } from '@angular/material/radio';
import { ClinicSearchModule } from '../../../shared/components/clinic-search/clinic-search.module';

@NgModule({
  declarations: [
    SccRegisterComponent,
    SccUserComponent,
    SccPaymentComponent,
    SccPaymentMethodInputComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    SccRegisterRoutingModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    MatStepperModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCardModule,
    SccPasswordModule,
    AutocompleteSelectorModule,
    MatRadioModule,
    ClinicSearchModule,
    SccClinicModule
  ],
  exports: [
    SccRegisterComponent,
    SccPaymentMethodInputComponent
  ],
  providers: [ AuthenticationService ]
})
export class SccRegisterModule { }
